import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProviderPriceList } from '../../../models/Entities/ProviderAssociations/PriceLists/ProviderPriceList';
import { PriceListCards } from '../PriceListCards/PriceListCards.Component';

export interface IProps {
  priceList: ProviderPriceList[];
  onSelectPriceList?: (PriceList: ProviderPriceList) => void;
  /** Selección controlada desde la página (p. ej. para limpiarla al borrar la lista). */
  selectedId?: number;
  /** Mientras se cargan las listas del proveedor. */
  loading?: boolean;
  /** Acción del estado vacío (normalmente el botón "Agregar lista"). */
  emptyAction?: React.ReactNode;
}

/** Listas de precios del proveedor: las tarjetas comunes de la guía con los textos del proveedor. */
export const ProviderPriceListComponent = (props: IProps) => {
  const [t] = useTranslation();
  return (
    <PriceListCards<ProviderPriceList>
      priceList={props.priceList}
      onSelectPriceList={props.onSelectPriceList}
      selectedId={props.selectedId}
      loading={props.loading}
      loadingLabel={t('providerPriceList.loadingBlock.loading')}
      emptyTitle={t('providerPriceList.loadingBlock.noPriceList')}
      emptyText={t('providerPriceList.emptyText')}
      emptyAction={props.emptyAction}
      testId="ppl-list"
    />
  );
};

export default ProviderPriceListComponent;
